import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import English from '../assets/locales/en/translation.json';
import French from '../assets/locales/fr/translation.json';

const resources = {
  en: {
    translation: English,
  },
  fr: {
    translation: French,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr'],
    resources,
    fallbackLng: 'en',
    debug: true,
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],
    },
    react: { useSuspense: false },
  });

export default i18n;
